new Vue({
  el: '#faq',
  delimiters: ["<%","%>"],
  data() {
    return {
      query: '',
    };
  },
  computed: {
    normalizedQuery() {
      return this.query.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim()
        .replace(/  +/g, ' ');
    },
  },
  methods: {
    showQuestion(title) {
      const normalizedTitle = title.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim()
        .replace(/  +/g, ' ');
      return (normalizedTitle.indexOf(this.normalizedQuery) !== -1);
    },
  },
});